import { Tooltip as ReactTooltip } from 'react-tooltip';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledTooltip = styled(ReactTooltip)`
  white-space: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  z-index: 999;
  background-color: ${(props) =>
    props.backgroundColor || props.theme.COLOR_BLACK};
  color: ${({ $textColor }) => $textColor ?? '#fff'} !important;
  max-width: 250px;
`;

const Icon = styled.span`
  cursor: default;
  svg {
    color: ${(props) => props.theme.COLOR_GREY_TEXT};
  }
`;

const Span = styled.span`
  color: ${(props) => props.theme.tableIconColor};
  cursor: default;
`;

const TooltipContainer = styled.span`
  display: inline-block;
`;

/**
 * Tooltip component.
 * @param {object} props The props object.
 * @param {object} props.icon The icon to display.
 * @param {string} props.backgroundColor The background color of the tooltip.
 * @param {string} props.textColor The text color of the tooltip.
 * @param {string} props.text The text to display.
 * @param {string} props.id The id attribute.
 * @param {string} props.toolTipText The tooltip text.
 * @returns {JSX.Element} The rendered Tooltip component.
 */
const Tooltip = (props) => {
  const { icon, backgroundColor, textColor, text, id, toolTipText } = props;
  if (!id) {
    throw new Error('Tooltip id prop is required.');
  }
  return (
    <TooltipContainer>
      {icon ? (
        <Icon
          id={id}
          data-tooltip-content={text}
          data-tooltip-place="top"
          data-tooltip-position-strategy="fixed"
        >
          {icon}
        </Icon>
      ) : (
        <Span
          id={id}
          data-tooltip-content={toolTipText}
          data-tooltip-position-strategy="fixed"
          data-tooltip-place="top"
        >
          {text}
        </Span>
      )}
      <StyledTooltip
        place="top"
        anchorId={id}
        $textColor={textColor}
        backgroundColor={backgroundColor}
        effect="solid"
      />
    </TooltipContainer>
  );
};

Tooltip.defaultProps = {
  textColor: '#fff',
  backgroundColor: undefined,
  icon: undefined,
  toolTipText: undefined,
};

Tooltip.propTypes = {
  icon: PropTypes.object,
  text: PropTypes.string.isRequired,
  toolTipText: PropTypes.string,
  textColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  id: PropTypes.string.isRequired,
};

export default Tooltip;
